import React from 'react';
import WaveIcon from '../../../../../icons/Wave';
import ArrowUpIcon from '../../../../../icons/Arrow/Up';
import ArrowIcon from '../../../../../icons/ArrowB';
import WarnBIcon from '../../../../../icons/Warn/B';

function CircleA(props) {
  return (
    <div
      {...props}
      className={`sq(|min)24 layoutRow fhaC fvaC r ov `
        + (props.className || '')}
    />
  );
}

export const DEFAULT_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#FFBF43"/>
    <path d="M11.4 9.6C11.4 9.26863 11.6686 9 12 9C12.3314 9 12.6 9.26863 12.6 9.6V11.7515L14.2243 13.3757L14.2351 13.3868C14.4585 13.6219 14.4549 13.9936 14.2243 14.2243C13.9936 14.4549 13.6219 14.4585 13.3868 14.2351L13.3757 14.2243L11.4 12.2485V9.6Z" fill="white"/>
    <path d="M16.8 12C16.8 9.34903 14.651 7.19999 12 7.19999C9.34903 7.19999 7.19999 9.34903 7.19999 12C7.19999 14.651 9.34903 16.8 12 16.8C14.651 16.8 16.8 14.651 16.8 12ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" fill="white"/>
  </svg>
);
export const COMPLETED_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#5B47FF"/>
    <path d="M16.3606 13.3736L16.3437 8.57092C16.3437 8.50303 16.3267 8.45212 16.3267 8.38424C16.3267 8.3503 16.3097 8.33333 16.3097 8.29939C16.3097 8.26545 16.2927 8.24847 16.2758 8.19756C16.2588 8.18059 16.2588 8.14665 16.2249 8.11271C16.2079 8.09574 16.2079 8.0618 16.1909 8.04483L16.0891 7.943C16.0552 7.90906 16.0042 7.85815 15.9533 7.84118C15.9364 7.82421 15.9024 7.82421 15.8854 7.80724C15.8685 7.79027 15.8345 7.79027 15.8176 7.7733C15.8006 7.75633 15.7667 7.75633 15.7327 7.75633C15.6818 7.70542 15.6479 7.70542 15.6479 7.70542C15.5969 7.68845 15.5291 7.68845 15.4612 7.68845L10.6585 7.67148C10.4209 7.67148 10.2003 7.75633 10.0306 7.92603C9.8609 8.09574 9.77604 8.31636 9.77604 8.55394C9.77604 8.79153 9.8609 9.01215 10.0306 9.18186C10.2003 9.35156 10.4209 9.43641 10.6585 9.43641L13.3059 9.43641L7.92625 14.8161C7.58684 15.1555 7.58684 15.7325 7.92625 16.0719C8.26566 16.4113 8.84266 16.4113 9.18207 16.0719L14.5617 10.6922L14.5617 13.3396C14.5617 13.5772 14.6466 13.7978 14.8163 13.9676C14.986 14.1373 15.2066 14.2221 15.4442 14.2221C15.6818 14.2221 15.9024 14.1373 16.0721 13.9676C16.2418 13.8318 16.3606 13.6112 16.3606 13.3736Z" fill="white"/>
  </svg>
);
export const CANCELED_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="12" fill="#EE4F4F"/>
    <path d="M8.22138 8.22137C7.92621 8.51654 7.92621 8.9951 8.22138 9.29027L10.9311 12L8.22138 14.7098C7.92621 15.0049 7.92621 15.4835 8.22138 15.7786C8.51654 16.0738 8.9951 16.0738 9.29027 15.7786L12 13.0689L14.7098 15.7786C15.0049 16.0738 15.4835 16.0738 15.7786 15.7786C16.0738 15.4835 16.0738 15.0049 15.7786 14.7098L13.0689 12L15.7786 9.29028C16.0738 8.99512 16.0738 8.51655 15.7786 8.22139C15.4834 7.92622 15.0049 7.92622 14.7098 8.22139L12 10.9311L9.29027 8.22137C8.9951 7.92621 8.51654 7.92621 8.22138 8.22137Z" fill="white"/>
  </svg>
);

export const ICONS_MAP = {
  initiated: DEFAULT_ICON,
  pending: DEFAULT_ICON,
  completed: COMPLETED_ICON,
  paid: COMPLETED_ICON,
  sent: COMPLETED_ICON,
  cancelled: CANCELED_ICON,
  failed: CANCELED_ICON,
};
